import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Services } from "./components/services";
import { Process } from "./components/process";
import { Features } from "./components/features";
import { Industries } from "./components/industries";
import { About } from "./components/about";
import { CtaBanner } from "./components/cta-banner";
import { Contact } from "./components/contact";
import { GuruGobindSinghGurpurab } from "./pages/events/GuruGobindSinghGurpurab";
import { EventsPage } from "./pages/events/EventsPage";
import { ProjectsPage } from "./pages/projects/ProjectsPage";
import { RealtorProject } from "./pages/projects/RealtorProject";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { ContactRead } from "./components/contact-read";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Landing Page Component
const LandingPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Header data={landingPageData.Header} />
      <Services data={landingPageData.Services} />
      <Process />
      <Features data={landingPageData.Features} />
      <Industries />
      <About data={landingPageData.About} />
      <CtaBanner />
      <Contact data={landingPageData.Contact} />
      {window.location.href.indexOf("key=priyanka") !== -1 && <ContactRead />}
    </div>
  );
};

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        {/* Navigation appears on all pages */}
        <Navigation />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/realtor-parminder-singh" element={<RealtorProject />} />
          <Route path="/community" element={<EventsPage />} />
          <Route path="/community/27-dec-2025-guru-gobind-singh-gurpurab" element={<GuruGobindSinghGurpurab />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
};

export default App;
